import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/views/layout/Layout'
/* Router Modules */
import nestedRouter from './modules/nested'

Vue.use(Router)
/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
 **/
export const constantRouterMap = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authredirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: 'dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          title: 'dashboard',
          icon: 'dashboard',
          noCache: true,
          enName: 'HOME_PAGE_SHOW'
        }
      },
      {
        path: '/401',
        component: () => import('@/views/errorPage/401'),
        hidden: true
      }
    ]
  }
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/setting',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: 'setting',
      icon: 'example'
    },
    children: [
      {
        path: 'pay',
        component: () => import('@/views/setting/pay'),
        name: '支付方式',
        meta: {
          title: 'pay',
          enName: 'GROUP_MGR_PAY_TYPE',
          roles: ['admin'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'card',
        component: () => import('@/views/setting/card'),
        name: '卡片库存',
        meta: {
          title: 'card',
          enName: 'GROUP_MGR_CARD'
        }
      },
      {
        path: 'reserve',
        component: () => import('@/views/setting/Reserve'),
        name: 'reserve',
        meta: {
          title: '集团配置',
          enName: 'GROUP_SETTING'
        }
      },
      {
        path: 'emp',
        component: () => import('@/views/setting/emp'),
        name: 'emp',
        meta: {
          title: 'emp',
          enName: 'GROUP_MGR_EMP'
        }
      }
    ]
  },
  nestedRouter,
  {
    path: '/record',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: 'record',
      icon: 'list'
    },
    children: [
      {
        path: 'fuel',
        component: () => import('@/views/record/fuel'),
        name: 'fuel',
        meta: {
          title: 'fuel',
          enName: 'FUEL_RECORD_SHOW'
        }
      },
      /* {
        path: 'amount',
        component: () => import('@/views/record/index'),
        props: { opType: 'amount' },
        name: 'amount',
        meta: {
          title: 'amount'
        }
      },*/
      {
        path: 'charge',
        component: () => import('@/views/record/index'),
        name: 'charge',
        props: { opType: 'charge', enName: 'RECHARGE_RECORD_SHOW' },
        meta: {
          title: 'charge',
          enName: 'RECHARGE_RECORD_SHOW'
        }
      },
      /*      {
        path: 'refund',
        component: () => import('@/views/record/index'),
        name: 'refund',
        props: { opType: 'refund' },
        meta: {
          title: 'refund'
        }
      },*/
      {
        path: 'close',
        component: () => import('@/views/record/index'),
        props: { opType: 'close', enName: 'CLOSE_RECORD_SHOW' },
        name: 'close',
        meta: {
          title: 'close',
          enName: 'CLOSE_RECORD_SHOW'
        }
      },
      {
        path: 'reportForms',
        component: () => import('@/views/record/ReportFormOri'),
        // props: { opType: 'reportForms' },
        name: 'reportForms',
        meta: {
          title: '日报表',
          enName: 'DAILY_REPORT_SHOW'
        }
      },
      {
        path: 'shiftReport',
        component: () => import('@/views/record/shiftReport'),
        // props: { opType: 'reportForms' },
        name: 'shiftReport',
        meta: {
          title: '班次报表',
          enName: 'CLASSES_REPORT_SHOW'
        }
      },
      /*      {
        path: 'dailyReport',
        component: () => import('@/views/record/DailyReport'),
        // props: { opType: 'reportForms' },
        name: '日报',
        meta: {
          title: '日报'
        }
      },*/
      {
        path: 'smsList',
        component: () => import('@/views/record/sms/list'),
        // props: { opType: 'reportForms' },
        name: 'smsList',
        meta: {
          title: '短信记录',
          enName: 'SMS_RECORD_SHOW'
        }
      }
      /* {
        path: 'point',
        component: () => import('@/views/record/index'),
        props: { opType: 'point' },
        name: 'point',
        meta: {
          title: 'point'
        }
      }*/
    ]
  },
  {
    path: '/station',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: 'station',
      icon: 'star'
    },
    children: [
      {
        path: 'feulList',
        component: () => import('@/views/station/list'),
        name: 'feulList',
        meta: {
          title: 'feulList',
          enName: 'STATION_LIST_SHOW'
        }
      },
      /*      {
        path: 'listFp',
        component: () => import('@/views/station/listFp'),
        name: 'listFp',
        meta: {
          title: 'listFp'
        }
      },*/
      {
        path: 'list4gFp',
        component: () => import('@/views/station/list4gFp'),
        name: 'List4gFp',
        meta: {
          title: '油枪列表',
          enName: 'FP_LIST_SHOW'
        }
      }
      /* {
        path: 'listTank',
        component: () => import('@/views/station/listTank'),
        name: 'listTank',
        meta: {
          title: 'listTank'
        }
      }*/
    ]
  },
  {
    path: '/stockManage',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: 'stockManage',
      icon: 'user'
    },
    children: [
      {
        path: 'nowStock',
        component: () => import('@/views/stockManage/nowStock'),
        name: 'nowStock',
        meta: {
          title: 'nowStock',
          enName: 'STOCK_SHOW'
        }
      },
      {
        path: 'inOilRecord',
        component: () => import('@/views/stockManage/inOilRecord'),
        name: 'inOilRecord',
        meta: {
          title: 'inOilRecord',
          enName: 'IN_OIL_RECORD_SHOW'
        }
      }
    ]
  },
  {
    path: '/video',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: 'video',
      icon: 'size'
    },
    children: [
      {
        path: 'videoList',
        component: () => import('@/views/video/videoList'),
        name: 'videoList',
        meta: {
          title: 'videoList',
          enName: 'VEDIO_MONITOR_SHOW'
        }
      },
      {
        path: 'playVideo',
        component: () => import('@/views/video/playVideo'),
        name: 'playVideo',
        hidden: true,
        meta: {
          title: 'playVideo'
        }
      }
    ]
  },
  /*
  {
    path: '/sms',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      title: '短信',
      icon: 'table'
    },
    children: [
      {
        path: 'smsList',
        component: () => import('@/views/sms/list'),
        name: 'List',
        meta: {
          title: '短信记录'
        }
      }
    ]
  },*/
  {
    path: '/testing',
    component: () => import('@/views/testing/testing'),
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true }
]
